import Stencil from "../stencil";
import StencilHTMLElement from "./stencil-element";

class RecentlyViewed extends StencilHTMLElement {
  view = "product-cards";
  maxHandles = 30;
  limit;
  presentation;

  constructor() {
    super();
  }

  connectedCallback() {
    this.limit = parseInt(this.getAttribute('limit') || "8");
    this.presentation = this.getAttribute('presentation') || 'carousel';

    if (Stencil.isProductPage()) {
      this.storeProductView();
    } 
    this.render();
  }

  /**
  * Render the panel()
  */
  render() {
    const handles = this.getRecentlyViewed();
    const url = this.buildFetchUrl(handles);
    this.fetch(url);
  }

  /**
  * Generate a fetch URL to the /search raw view (template)
  * @param {Array} handles 
  * @returns {String} URL to fetch
  */
  buildFetchUrl(handles) {
    const prefixedHandles = handles.map(e => `handle:${e}`).join("+OR+");
    return `/search?q=${prefixedHandles}&type=product&view=${this.view}`;
  }

  /**
   * Perform a fetch from the server
   * @param {String} url 
   */
  async fetch(url) {
    try {
      const response = await fetch(url);
      const data = await response.json();
      this.onFetchedCards(data.cards);
    } catch (error) {
      console.error(this.logPrefix, 'Error fetching cards: ', error);
    }
  }

  /**
   * Generate cards for the fetched products
   * @param {Array} cards HTML cards returned from fetch
   */
  onFetchedCards(cards) {
    if (cards.length > 0) {
      const limitedCards = cards.slice(0, this.limit);
      const cardContainer = this.querySelector(".rv-card-container");

      switch (this.presentation) {
        case "stack":
          cardContainer.innerHTML = "";
          const columnClass = this.dataset.columnClass || "";
          limitedCards.forEach(card => {
            cardContainer.insertAdjacentHTML('beforeend', `<div class="${columnClass}">${card}</div>`);
          });
          break;
        case "carousel":
          const carousel = this.querySelector(".rv-carousel");
          const carouselSlides = carousel.querySelector(".swiper-wrapper");
          limitedCards.forEach(card => {
            carouselSlides.insertAdjacentHTML('beforeend', `<div class="swiper-slide"><div class="px-1 h-100">${card}</div></div>`);
          });
          cardContainer.remove();
          carousel.classList.remove("d-none");
          break;
      }

      // Generate the necessary offcanvas elements for the card
      // Note: Since the cards will be inserted after JS has been loaded and
      //  run, here we are finding all the relative script tags in the html 
      // code that the backend has served and eval(run) it.
      this.querySelectorAll(`script[id^='offcanvas-injection--']`).forEach(e => {
        (0, eval)(e.innerText);
      });
    }
  }

  /**
   * Get recently viewed product handles
   * @returns {Array} Handles
   */
  getRecentlyViewed() {
    const recentlyViewedHandles = localStorage.getItem('rv-handles');
    if (recentlyViewedHandles === null || recentlyViewedHandles === '') {
      return [];
    }
    return JSON.parse(recentlyViewedHandles).filter(e => e !== "");
  }

  /**
   * Store the handle of the current product as a recently viewed product
   */
  storeProductView() {
    const recentlyViewedHandles = this.getRecentlyViewed();
    const currentHandle = window.location.pathname.replace(/\/$/, "").split("/").pop();

    if (!recentlyViewedHandles.includes(currentHandle)) {
      recentlyViewedHandles.push(currentHandle);

      if (recentlyViewedHandles.length > this.maxHandles) {
        recentlyViewedHandles.shift(); // Remove the oldest product if the limit is exceeded
      }

      localStorage.setItem('rv-handles', JSON.stringify(recentlyViewedHandles));
    }
  }
}

export default RecentlyViewed;